import SpriteSymbol from "../../../../../../../shared/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../config/webpack/loaders/svg-sprite/utils/sprite";
var symbol = new SpriteSymbol({
  "id": "icon__mail",
  "use": "icon__mail-usage",
  "viewBox": "0 0 20 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 16\" id=\"icon__mail\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 0a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V2a2 2 0 00-2-2H2zm0 3l-.614.79L10 10.633l8.614-6.845L18 3l-8 6.367L2 3z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol